import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  Workflow = 'Workflow',
  Results = 'Results',
  Goal = 'Goal',
  GoalsOptions = 'GoalsOptions',
}

export const queryKeys = {
  workflow: (clientId: string) => [QueryFeature.PulseCheck, QueryKey.Workflow, clientId],

  results: (clientId: string) => [QueryFeature.PulseCheck, QueryKey.Results, clientId],

  goal: (clientId: string, goalId: string) => [
    QueryFeature.PulseCheck,
    QueryKey.Goal,
    clientId,
    goalId,
  ],

  goalsOptions: (clientId: string, categoryId: string) => [
    QueryFeature.PulseCheck,
    QueryKey.GoalsOptions,
    clientId,
    categoryId,
  ],

  goalsOptionsAll: () => [QueryFeature.PulseCheck, QueryKey.GoalsOptions],
};
